import React from 'react';

import { addPerson } from '@/assets/icons';
import { Button, SvgIcon } from '@material-ui/core';

import styles from './AddTeamMember.module.scss';

export interface AddTeamMemberButtonProps {
	onClick: () => void;
}

export const AddTeamMemberButton = ({ onClick }: AddTeamMemberButtonProps) => {
	return (
		<Button
			disableElevation
			variant="contained"
			color="default"
			size="small"
			startIcon={<SvgIcon component={addPerson} />}
			classes={{ root: styles['btn'] }}
			onClick={onClick}
		>
			Invite Team Member
		</Button>
	);
};
